// apps/client/src/assets/builders/shell.ts — beach shells by catalog id
import * as THREE from 'three';
import type { CodeBuilder } from '../service';
import { toyMaterial } from '../../characters/doll';
const SHELLS: Record<string, () => THREE.Object3D> = {
  'shell.cockle': () => new THREE.Mesh(new THREE.SphereGeometry(0.11, 14, 8, 0, Math.PI * 2, 0, Math.PI / 2).scale(1, 0.6, 1), toyMaterial('#F2D9C4')),
  'shell.cowrie': () => new THREE.Mesh(new THREE.SphereGeometry(0.1, 14, 10).scale(1.3, 0.55, 0.9), toyMaterial('#E9D2A8')),
  'shell.scallop': () => new THREE.Mesh(new THREE.CylinderGeometry(0.13, 0.13, 0.03, 16, 1, false, -0.9, 1.8), toyMaterial('#F4B98A')),
  'shell.sand_dollar': () => new THREE.Mesh(new THREE.CylinderGeometry(0.12, 0.12, 0.02, 20), toyMaterial('#EEDFC4')),
  'shell.conch': () => new THREE.Mesh(new THREE.ConeGeometry(0.08, 0.24, 12).rotateZ(Math.PI / 2), toyMaterial('#F3C6A8')),
};
export const builder: CodeBuilder = {
  id: 'shell',
  build(p) {
    const g = new THREE.Group();
    const m = (SHELLS[String(p.catalogId)] ?? SHELLS['shell.cockle']!)();
    m.position.y = 0.04; g.add(m);
    return g;
  },
};
